/*
 * telemedicine-session (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { telemedicineSessions, SESSION_STATUSES } from "./telemedicine-session.schema"

export { SESSION_STATUSES }
export type SessionStatus = (typeof SESSION_STATUSES)[number]

/* Select */
export type TelemedicineSession = z.infer<typeof selectTelemedicineSessionSchema>
export const selectTelemedicineSessionSchema = createSelectSchema(telemedicineSessions)

/* Filters */
export type TelemedicineSessionFilters = z.infer<typeof telemedicineSessionFiltersSchema>
export const telemedicineSessionFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	practitionerId: z.string().optional(),
	appointmentId: z.string().optional(),
	status: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createTelemedicineSessionSchema = createInsertSchema(telemedicineSessions)
	.partial(globalCreateExclude)
export type CreateTelemedicineSession = z.infer<typeof createTelemedicineSessionSchema>

/* Update */
export const updateTelemedicineSessionSchema = createInsertSchema(telemedicineSessions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateTelemedicineSession = z.infer<typeof updateTelemedicineSessionSchema>
